import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SoftwareConsultingComponent } from './software-consulting.component';

const routes: Routes = [{
    path: '',
    component: SoftwareConsultingComponent 
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SoftwareConsultingRoutingModule { }
